import React from 'react'
import { NavLink } from 'react-router-dom';

function PageNotFound() {
  return (
    <>
      <div className='page_not_found'>

      <section className="flex items-center h-full p-16 dark:bg-[#111920] dark:text-white">
	<div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
		<div className="max-w-md text-center">
			<h2 className="mb-8 font-extrabold text-9xl dark:text-gray-400">
				<span className="sr-only">Error</span>404
			</h2>
			<p className="text-2xl font-semibold md:text-3xl mb-20">Sorry, we couldn't find this page.</p>
			<NavLink rel="noopener noreferrer" to="/" className="  px-8 py-3 font-semibold rounded bg-black text-white dark:bg-[#222A32] dark:text-gray-50">Back to homepage</NavLink>
		</div>
	</div>
</section>
      </div>
    </>
  )
}

export default PageNotFound;
